import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { SessionService } from "src/app/services/storage/session.service";

/**
 * Why does this simple component exists?
 * 
 * To handle translation in one component instead of every component.
 * There are some cases where we do not want to translate text.
 * 
 * If text is set to an object, jsonKey must also be set to an object
 * 
 * for innerHTML set [isHTML]="true"
*/

@Component({
    selector: 'mwp-text-translate',
    templateUrl: './text-translate.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextTranslateComponent implements OnInit {
    @Input() public text: string;
    @Input() public jsonKey: string;
    @Input() public isHTML: boolean;

    constructor(
        public sessionService: SessionService
    ) { 
    }

    ngOnInit(): void {
       if (this.jsonKey?.includes(" ")) {
            this.jsonKey = this.jsonKey.replace(/\s+/g, '');
        } else if (!this.jsonKey) {
            this.jsonKey = this.text;
        }
    }
}